var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editor-module",
      class: _vm.computedClasses,
      style: _vm.computedStyles,
    },
    [
      _c(
        "div",
        {
          ref: "editorModuleTopToolbar",
          staticClass: "editor-module-top-toolbar",
          class: _vm.editorModuleTopToolbarClasses,
        },
        [
          _vm.isMobile
            ? _c("EditorTextCTAButtonsView", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.areToolbarsVisible,
                    expression: "!areToolbarsVisible",
                  },
                ],
                attrs: { "done-disabled": _vm.isTextObjectEmpty },
                on: {
                  cancel: _vm.onTextCTAButtonsCancel,
                  done: _vm.onEditorTextDone,
                },
              })
            : _vm._e(),
          _c("EditorTopToolbarView", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.areToolbarsVisible,
                expression: "areToolbarsVisible",
              },
            ],
            attrs: {
              "currency-model": _vm.currencyModel,
              "editor-product-settings-model": _vm.editorProductSettingsModel,
              "has-multiple-photo-support": _vm.pageMultiplePhotoSupport,
              "has-photo-selected": !!_vm.photoObjectSelected,
              "is-compact-and-filled":
                !_vm.isMobile &&
                !!_vm.photoObjectSelected &&
                (_vm.isProjectSinglePage || _vm.pageMultiplePhotoSupport),
              "is-preview-mode-active": _vm.isPreviewModeActive,
              "is-redo-enabled": _vm.isRedoEnabled,
              "is-undo-enabled": _vm.isUndoEnabled,
              "offering-model-price": _vm.fullOfferingModelPrice,
              "project-model": _vm.projectModel,
              "show-additional-menu": _vm.showEditorTopToolbarAdditionalMenu,
            },
            on: {
              back: _vm.onEditorTopToolbarBack,
              cancel: _vm.onEditorTopToolbarCancel,
              "done-adjusting": _vm.onDoneAdjustingClick,
              "done-editing": _vm.onEditorTopToolbarDoneEditing,
              "product-settings-change":
                _vm.onEditorTopToolbarProductSettingsChange,
              redo: _vm.onEditorTopToolbarRedo,
              save: _vm.onEditorTopToolbarSave,
              undo: _vm.onEditorTopToolbarUndo,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: _vm.offeringOptionsSummaryToolbarSlotName,
                  fn: function () {
                    return [
                      _c("OfferingOptionsSummaryToolbarView", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showOfferingOptionsSummaryToolbar,
                            expression: "showOfferingOptionsSummaryToolbar",
                          },
                        ],
                        attrs: {
                          "bleed-margin": _vm.bleedMargin,
                          "currency-model": _vm.currencyModel,
                          "filter-tags":
                            _vm.offeringOptionsSummaryToolbarFilterTags,
                          "full-offering-models": _vm.fullOfferingModels,
                          "is-project-single-page": _vm.isProjectSinglePage,
                          "only-offering-name":
                            _vm.offeringOptionsSummaryToolbarOnlyOfferingName,
                          "only-summary":
                            _vm.offeringOptionsSummaryToolbarOnlySummary,
                          "page-model": _vm.pageModel,
                          "page-objects": _vm.pageObjects,
                          "preview-model": _vm.offeringModelModel2D,
                          value: _vm.fullOfferingModel,
                        },
                        on: { change: _vm.onOfferingOptionValueChange },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c("divider", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isMobile,
            expression: "!isMobile",
          },
        ],
        staticClass: "divider full horizontal",
      }),
      _c(
        "div",
        {
          staticClass: "editor-module-toolbar",
          class: _vm.editorModuleToolbarClasses,
        },
        [
          _c("EditorToolbarView", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.areToolbarsVisible && !_vm.isPreviewModeActive,
                expression: "areToolbarsVisible && !isPreviewModeActive",
              },
            ],
            ref: "editorToolbar",
            attrs: {
              "active-mode": _vm.editorToolbarActiveMode,
              canvas: _vm.canvasElement,
              disabled: _vm.isEditorToolbarDisabled,
              "has-multiple-objects-of-kind":
                _vm.photoObjects.length > 1 || _vm.textObjects.length > 1,
              "has-preview": _vm.productHasPreview,
              "has-photo-object": !!_vm.photoObjects.length,
              "has-text-object": !!_vm.textObjects.length,
              "is-add-photo-available": _vm.isAddPhotoAvailable,
              layouts: _vm.templateSets,
              objects: _vm.pageObjects,
              "page-model": _vm.pageModel,
              "photo-object": _vm.photoObjectSelected,
              photos: _vm.photos,
              "product-type": _vm.currentOfferingModel.type,
              "project-model": _vm.projectModel,
              "project-theme": _vm.projectThemeModel,
              themes: _vm.offeringModelThemeModels,
              "tools-supported": _vm.productToolsSupported,
            },
            on: {
              "active-mode-change": _vm.onToolbarEditorModeChange,
              "add-frame": _vm.onToolbarAddFrame,
              "add-object": _vm.onToolbarAddObject,
              "add-photo": _vm.onAddPhoto,
              change: _vm.onToolbarChange,
              delete: _vm.onToolbarDelete,
              "delete-page": _vm.onToolbarDeletePage,
              "eye-dropper-end": _vm.onEyeDropperEnd,
              "eye-dropper-start": _vm.onEyeDropperStart,
              "layout-change": _vm.onToolbarLayoutChange,
              "objects-change": _vm.onToolbarObjectsChange,
              "page-model-change": _vm.onPageModelChange,
              preview: _vm.onPreviewModeToggle,
              "project-theme-change": _vm.onToolbarProjectThemeChange,
              "push-changes": _vm.onEditorPushChanges,
              shuffle: _vm.onToolbarShuffle,
            },
            nativeOn: {
              mouseenter: function ($event) {
                return _vm.onToolbarPaginationMouseEnter.apply(null, arguments)
              },
              mouseleave: function ($event) {
                return _vm.onToolbarPaginationMouseLeave.apply(null, arguments)
              },
            },
          }),
          _c(
            "div",
            {
              ref: "editorMainSection",
              staticClass: "editor-module-main-section",
              on: { scroll: _vm.onEditorMainSectionScroll },
            },
            [
              _vm.isPreviewModeActive
                ? _c("EditorPreviewView", {
                    staticClass: "editor-module-preview-view",
                    attrs: {
                      "bleed-margin": _vm.bleedMargin,
                      model2D: _vm.offeringModelModel2D,
                      model3D: _vm.offeringModelModel3D,
                      "offering-frame-model": _vm.offeringFrameModel,
                      "offering-model": _vm.fullOfferingModel,
                      "page-model": _vm.pageModel,
                      "page-objects": _vm.pageObjects,
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isCropModeActive,
                      expression: "isCropModeActive",
                    },
                  ],
                  ref: "editorCanvasCropContainer",
                  staticClass: "editor-module-canvas-crop-container",
                },
                [
                  _vm.isCropModeActive
                    ? [
                        _c("EditorDrawView", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.cropGridCroppingMouseDown ||
                                _vm.cropGridMovingMouseDown ||
                                _vm.zoomTooltipMouseDown,
                              expression:
                                "cropGridCroppingMouseDown || cropGridMovingMouseDown || zoomTooltipMouseDown",
                            },
                          ],
                          key: _vm.cropPhotoObject.id,
                          staticClass: "editor-draw-page-object-view",
                          style: _vm.cropPhotoObjectStyles,
                          attrs: {
                            "bleed-margin": _vm.bleedMargin,
                            "draw-objects": [_vm.cropPhotoObject],
                            height: _vm.cropPhotoObject.height,
                            "is-crop-mode-active": true,
                            "offering-model": _vm.fullOfferingModel,
                            "page-model": _vm.pageModel,
                            scaling: _vm.offeringFrameScaling,
                            width: _vm.cropPhotoObject.width,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isPreviewModeActive,
                      expression: "!isPreviewModeActive",
                    },
                  ],
                  ref: "canvasContainer",
                  staticClass: "editor-module-canvas-container",
                },
                [
                  _c("EditorCanvasView", {
                    ref: "editorCanvas",
                    attrs: {
                      "is-eye-dropper-shown": _vm.isEyeDropperShown,
                      "is-interactive": true,
                      "is-photo-object-transformable":
                        _vm.isPageTemplateTransformable,
                      "is-text-overlay-active":
                        _vm.projectModelHasOverview && !_vm.areToolbarsVisible,
                      "multiple-photo-support": _vm.pageMultiplePhotoSupport,
                      "multiple-text-support": _vm.productMultipleTextSupport,
                      "object-actions-anchor": !_vm.isMobile
                        ? null
                        : _vm.editorMainSectionElement,
                      "offering-frame-model": _vm.offeringFrameModel,
                      "offering-model": _vm.fullOfferingModel,
                      "page-index": _vm.pageIndex,
                      "page-model": _vm.virtualPageModel,
                      "page-objects": _vm.virtualPageObjects,
                      "page-template-positions-available":
                        _vm.pageTemplatePositionsAvailable,
                      scaling: _vm.scaling,
                      "show-editor-offering-frame": _vm.showEditorOfferingFrame,
                      "show-bleed": _vm.showBleed,
                    },
                    on: {
                      "add-photo": _vm.onAddPhoto,
                      "add-text": _vm.onAddText,
                      "canvas-ready": _vm.onCanvasReady,
                      "delete-object": _vm.onEditorCanvasDeleteObject,
                      "eye-dropper-shown-change":
                        _vm.onEditorCanvasEyeDropperShownChange,
                      "page-model-change": _vm.onPageModelChange,
                      "page-object-change": _vm.onEditorCanvasPageObjectChange,
                      "page-objects-change":
                        _vm.onEditorCanvasPageObjectsChange,
                      "push-changes": _vm.onEditorPushChanges,
                    },
                  }),
                ],
                1
              ),
              _vm.isCropModeActive
                ? _c(
                    "div",
                    { staticClass: "editor-module-crop-grid-container" },
                    [
                      _c(
                        "div",
                        {
                          ref: "editorModuleCropGridWrapper",
                          staticClass: "editor-module-crop-grid-wrapper",
                          style: _vm.cropGridWrapperStyles,
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "editorModuleCropGrid",
                              staticClass: "editor-module-crop-grid",
                              on: {
                                mousedown: _vm.onCropGridMouseDown,
                                touchstart: _vm.onCropGridMouseDown,
                              },
                            },
                            [
                              _vm._m(0),
                              _vm._m(1),
                              _vm._m(2),
                              _vm._m(3),
                              _c("div", {
                                staticClass: "editor-module-crop-grid-square",
                              }),
                              _vm._m(4),
                              _vm._m(5),
                              _vm._m(6),
                              _vm._m(7),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.isMobile && _vm.isProjectSinglePage && _vm.isPreviewModeActive
                ? _c("PriceView", {
                    staticClass: "editor-module-preview-price-view",
                    attrs: {
                      cents: _vm.fullOfferingModelPrice,
                      currency: _vm.currencyModel
                        ? _vm.currencyModel.id
                        : undefined,
                    },
                  })
                : _vm._e(),
              _vm.isMobile && _vm.isProjectSinglePage
                ? _c(
                    "ButtonComponent",
                    {
                      staticClass: "editor-module-done-adjusting-button",
                      class: {
                        "editor-module-done-adjusting-button-hidden":
                          _vm.hasSelectedOrSelectedForEditionObject,
                      },
                      attrs: {
                        "font-size": !_vm.isPreviewModeActive
                          ? "--font-size-xs"
                          : "--font-size-s",
                        padding: !_vm.isPreviewModeActive ? 12 : [14, 26],
                        color: "primary",
                        width: "max-content",
                      },
                      on: { click: _vm.onDoneAdjustingClick },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "views.editorTopToolbar.buttons.done_adjusting"
                          )
                        )
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  ref: "editorPaginationContainer",
                  staticClass: "editor-module-pagination",
                  class: {
                    "editor-module-pagination-hidden": _vm.isPaginationHidden,
                  },
                },
                [
                  _c("EditorPaginationView", {
                    ref: "editorPagination",
                    attrs: {
                      disabled: _vm.isPaginationDisabled,
                      "offering-model": _vm.currentOfferingModel,
                      "page-list": _vm.editorPaginationPageList,
                      "total-pages": _vm.editorPaginationTotalPages,
                      value: _vm.editorPaginationValue,
                    },
                    on: {
                      change: _vm.onPaginationChange,
                      mouseenter: _vm.onToolbarPaginationMouseEnter,
                      mouseleave: _vm.onToolbarPaginationMouseLeave,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-top-left",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-vertical editor-module-crop-grid-line-vertical-left",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-corner-small editor-module-crop-grid-line-vertical-small",
            }),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-horizontal editor-module-crop-grid-line-horizontal-top editor-module-crop-grid-line-horizontal-left",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-horizontal-small",
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-top",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-horizontal editor-module-crop-grid-line-horizontal-top",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-horizontal-small",
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-top-right",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-vertical editor-module-crop-grid-line-vertical-right",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-corner-small editor-module-crop-grid-line-vertical-small",
            }),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-horizontal editor-module-crop-grid-line-horizontal-top editor-module-crop-grid-line-horizontal-right",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-horizontal-small",
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-left",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-vertical editor-module-crop-grid-line-vertical-left",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-vertical-small",
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-right editor-module-crop-grid-square-right",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-vertical editor-module-crop-grid-line-vertical-right",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-vertical-small",
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-bottom-left",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-horizontal editor-module-crop-grid-line-horizontal-bottom editor-module-crop-grid-line-horizontal-left",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-horizontal-small",
            }),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-vertical editor-module-crop-grid-line-vertical-left",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-corner-small editor-module-crop-grid-line-vertical-small",
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-bottom",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-horizontal editor-module-crop-grid-line-horizontal-bottom",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-horizontal-small",
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "editor-module-crop-grid-square editor-module-crop-grid-square-bottom-right",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-horizontal editor-module-crop-grid-line-horizontal-bottom editor-module-crop-grid-line-horizontal-right",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-horizontal-small",
            }),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "editor-module-crop-grid-line editor-module-crop-grid-line-vertical editor-module-crop-grid-line-vertical-right",
          },
          [
            _c("div", {
              staticClass:
                "editor-module-crop-grid-line-small editor-module-crop-grid-line-corner-small editor-module-crop-grid-line-vertical-small",
            }),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }